import React from "react";
import ControlPanel from "./giftCardEditor/ControlPanel";
import GiftCardPreview, { GiftCardOverlayPreview } from "./giftCardEditor/GiftCardPreview";
import { buildDefaultOverlays } from "./giftCardEditor/constants";

// Public API re-exports — kept identical to the pre-refactor module
// so `giftCardPrint.js` and `BrandGiftCertificates.jsx` (and any other
// consumer) continue to import from this same path without changes.
export {
  OVERLAY_SLOTS,
  buildDefaultOverlays,
  A5_PORTRAIT_MM,
  A5_LANDSCAPE_MM,
  A5_ASPECT,
} from "./giftCardEditor/constants";
export { GiftCardOverlayPreview };

/**
 * BrandGiftCertificates → Custom Overlay Editor.
 *
 * Left  : ControlPanel — title / tagline / message, image uploads,
 *         per-element sliders (X / Y / Size / Width / Height,
 *         alignment, colour).
 * Right : GiftCardPreview — live preview + Print A5 button. Same
 *         renderer used on the POS printed view so what the operator
 *         sees is what gets printed.
 */
export default function GiftCardOverlayEditor({ form, setForm }) {
  const overlays = form.overlays && Object.keys(form.overlays).length
    ? form.overlays
    : buildDefaultOverlays();

  const setOverlay = (key, patch) => {
    setForm((f) => ({
      ...f,
      overlays: {
        ...(f.overlays || buildDefaultOverlays()),
        [key]: { ...((f.overlays || {})[key] || {}), ...patch },
      },
    }));
  };

  return (
    <div className="grid md:grid-cols-2 gap-6 py-2">
      <ControlPanel
        form={form}
        setForm={setForm}
        overlays={overlays}
        setOverlay={setOverlay}
      />
      <GiftCardPreview form={form} overlays={overlays} />
    </div>
  );
}
